import {
	type FrontendPlacementMessage,
	type AnyFrontendStage,
} from '@post-office/message-maker-browser/types';

import VideoIcon from '@atlaskit/icon/core/video-next';

import IconTile from '@atlaskit/icon/icon-tile';

import { noValidation } from '@post-office/message-maker-browser/message-helpers';

import type { CreatePlacementMessageConfig } from '@post-office/message-template-contracts/placement-v2';

import {
	PlacementFrontend,
	type CustomPlacementProps,
} from '@post-office/browser--growth-starburst/project-assets-ai-suggestions';

import { FormattedMessage } from 'react-intl';

import { type MessageTemplateContext } from '../../..';

import { SuggestionCard } from '@post-office/browser--growth-starburst/common/components/suggestion-card';

export const MessageFrontend: (
	config: CreatePlacementMessageConfig,
) => FrontendPlacementMessage<{ render: AnyFrontendStage }> =
	PlacementFrontend.createMessageFrontend({
		render: {
			validate: noValidation<MessageTemplateContext>(),
			Component: ({ onSnoozeClick }: CustomPlacementProps & MessageTemplateContext) => {
				return (
					<SuggestionCard
						icon={<IconTile icon={VideoIcon} label="" appearance="magentaBold" size="small" />}
						title={
							<FormattedMessage
								id="post-office.project-assets-ai-suggestions.loom-meeting-notes.title"
								defaultMessage="Set up meeting notes"
								description="Title for the Loom meeting notes suggestion card"
							/>
						}
						description={
							<FormattedMessage
								id="post-office.project-assets-ai-suggestions.loom-meeting-notes.description"
								defaultMessage="Use Loom to record meetings and auto-create notes, so you never forget next steps."
								description="Description for the Loom meeting notes suggestion card"
							/>
						}
						ctaLabel={
							<FormattedMessage
								id="post-office.project-assets-ai-suggestions.loom-meeting-notes.cta"
								defaultMessage="Set up Loom"
								description="CTA button label for the Loom meeting notes suggestion card"
							/>
						}
						ctaIcon={undefined}
						onSnoozeClick={onSnoozeClick}
						onCtaClick={() => {
							globalThis.window?.open('https://loom.com/meetings/settings', '_blank');
						}}
					/>
				);
			},
		},
	});
